import { Button, Card, CardBody, CardFooter, Typography } from "@material-tailwind/react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import EmailField from "../../../UIComponents/Form/EmailField";

const ForgotPasswordCard: React.FC<ForgotPasswordCardProps> = ({ onClickFunction, setEmailForm, emailError, onEmailErrorClear }) => {
    const [email, setEmail] = useState('');
    const { t } = useTranslation();

    const setEmailOnChange = (email: string) => {
        setEmail(email);
        setEmailForm(email);
    };

    const handleForgotPasswordClick = () => {
        onClickFunction(email);
    };

    return (
        <Card shadow={false} className="w-[320px] lg:w-[400px] 2xl:w-[500px] h-[340px] lg:h-[295px] 2xl:h-[340px] px-[20px] lg:px-[25px] shadow-4s">
            <CardBody className="p-0">
                <Typography className="uppercase mt-[40px] text-xl 2xl:text-2xl font-bold text-#333333 text-center">
                    {t("TroubleLoggingIn")}?
                </Typography>
                <Typography className="mt-[20px] text-[14px] 2xl:text-xl text-#333333 text-center">
                    {t("EnterYouEmail")}.
                </Typography>
                <div className="mt-[28px] mb-[35px]">
                    <EmailField value={email} onValueChange={setEmailOnChange} errorMessage={emailError} onErrorClear={onEmailErrorClear} />
                </div>
            </CardBody>
            <CardFooter className="p-0">
                <Button id="sendBtn" className="text-[#161616] bg-#FF8136 hover:bg-#FF6104 h-[40px] w-full text-base 2xl:text-lg font-light p-0 uppercase shadow-none hover:shadow-none" onClick={handleForgotPasswordClick}>
                    {t("Send")}
                </Button>
            </CardFooter>
        </Card>
    );
}

export default ForgotPasswordCard;

interface ForgotPasswordCardProps {
    onClickFunction: (email: string) => void;
    setEmailForm: React.Dispatch<React.SetStateAction<string>>;
    emailError?: string;
    onEmailErrorClear?: () => void;
}
